import { FINANCE_PAGE_FLOWS } from './financeFlows.ts';
import { GENERAL_PAGE_FLOWS } from './generalFlows.ts';
import { OPERATIONS_PAGE_FLOWS } from './operationsFlows.ts';
import type { PageHelpFlow } from './types.js';

/** Explicit per-guide bindings; do not infer a financial process from a URL prefix. */
export const PAGE_HELP_FLOWS: Readonly<Record<string, readonly PageHelpFlow[]>> = {
  ...GENERAL_PAGE_FLOWS,
  ...FINANCE_PAGE_FLOWS,
  ...OPERATIONS_PAGE_FLOWS,
};
